// @flow

import React, { useCallback, type Node } from "react";

import { OkButton } from "@quantum/ui";

import { Translate } from "@quantum/i18n";

import "./pagina.css";
import { useHistory } from "react-router";

type Props = {
  titulo: string,
  children: Node,
};

const PaginaArquivos = ({ titulo, children }: Props) => {
  const history = useHistory();

  const voltarTelaPrincipal = useCallback(() => history.goBack(), [history]);

  return (
    <div className="PaginaArquivos">
      <nav className="PaginaArquivos__nav">
        <div className="PaginaArquivos__voltar">
          <OkButton
            onClick={voltarTelaPrincipal}
            className="PaginaArquivos__botao-voltar"
          >
            <Translate>botao.VOLTAR</Translate>
          </OkButton>
        </div>

        <h6 className="PaginaArquivos__titulo">{titulo}</h6>
      </nav>

      <section className="PaginaArquivos__corpo">{children}</section>
    </div>
  );
};

export default PaginaArquivos;
